<template>
  <div id = "debtNoteRollForward">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area">
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title"> Debt Note Roll Forward</div>
          <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
          <a href="javascript:void(0)" class="btn btn-secondary pull-right mr-2" v-on:click="exportReports()">
              <i class="fp-export"></i> Export
          </a>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content">
            <data-table-filter-config :moduleName="'debtNoteRollForward'" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="data-table bg-white">
                <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'debtNoteRollForward'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                      ref="debtNoteRollForwardTable"
                      mode="remote"
                      title="Debt Note Roll Forward"
                      @on-page-change="onPageChange"
                      @on-selected-rows-change="selectionChanged"
                      @on-column-filter="onColumnFilter"
                      @on-per-page-change="onPerPageChange"
                      @on-sort-change="onSortChange"
                      :totalRows="totalRecords"
                      :columns="userColumns"
                      :rows="rows"
                      :pagination-options="{
                          enabled: false,
                          position: 'bottom',
                          perPage: perPage,
                          perPageDropdown:dropDownPerPage,
                          dropdownAllowAll: false,
                      }"

                      :search-options="{
                      enabled: false,
                      }">

                  </vue-good-table>
                  <custom-pagination
                          :page-changed="onPageChange"
                          :per-page-changed="onPerPageChange">
                  </custom-pagination>
              </section>
              </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
            <div class="container-fluid">
                <div class="bg-white text-center">
                    <h1>
                        Oops!</h1>
                    <h2>
                        403 </h2>
                    <div class="error-details">
                        Sorry!, You don't have permission to access this page.
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <loading-content></loading-content>
        </template>
        <app-footer></app-footer>
      </div>
  </div>
</template>
<script>
import Vue from 'vue';


import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
   name: "DebtNoteRollForwardReport",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Debt Note Roll Forward | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
      permissions:[],
      cantAccessPage:'',
      loading:false,
      userColumns: [],
      columns: [
        {
            label: 'Note Number',
            field: 'note_number',
            hidden:false,
            fpFieldType:"text",
            filterable: true

        },
        {
            label: 'Financier Code',
            field: 'vendor_code',
            fpFieldType:"text",
            hidden:false,
            filterable: true,
        },
        {
            label: 'Financier Name',
            field: 'vendor_name',
            hidden:false,
            fpFieldType:"text",
            filterable: true

        },
        {
            label: 'Interest Rate',
            field: 'intereset_rate',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true

        },
        {
            label: 'Reference Number',
            field: 'reference_number',
            hidden:false,
            fpFieldType:"text",
            filterable: true

        },
        {
            label: 'Unit',
            field: 'asset_number',
            hidden:false,
            fpFieldType:"text",
            filterable: true

        },
        {
            label: 'Note Status',
            field: 'status',
            fpFieldType:"option",
            hidden:false,
            filterable: true,
            filterOptions:{
              filterDropdownItems: ["Entered","Active","Closed"],
            }

        },
        {
            label: 'Financing Start Date',
            field: 'financing_start_date',
            fpFieldType:"date",
            hidden:false,
            filterable: true

        },
        {
            label: 'Financing End Date',
            field: 'f_end_date',
            fpFieldType:"date",
            hidden:false,
            filterable: true

        },
        {
            label: 'Schedule Payout Date',
            field: 'sch_end_date',
            fpFieldType:"date",
            hidden:false,
            filterable: true

        },
        {
            label: 'Original Note Amount',
            field: 'note_amount',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: true

        },
        {
            label: 'Calculated Note Amount',
            field: 'calc_note_amount',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: false,
            sortable: false,

        },
        {
            label: 'Beginning Note Balance',
            field: 'begin_note_balance',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: false,
            sortable: false,

        },
        {
            label: 'Additions',
            field: 'additions',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: false,
            sortable: false,

        },
        {
            label: 'Principal Payments In Period',
            field: 'principal_pay',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: false,
            sortable: false,

        },
        {
            label: 'Ending Note Balance',
            field: 'end_note_balance',
            hidden:false,
            fpFieldType:"integer",
            type:'number',
            filterable: false,
            sortable: false,

        },
        {
            label: 'Activity',
            field: 'activity',
            fpFieldType:"option",
            hidden:false,
            filterable: false,
            sortable: false,

        },
        {
          label: 'Period Start Date',
          field: 'start_date',
          filterable: false,
          fpFieldType:"text",
          hidden:true,
          sortable:false,
          fpMandatory:true,
      },
      {
          label: 'Period End Date',
          field: 'end_date',
          filterable: false,
          fpFieldType:"text",
          hidden:true,
          sortable:false,
          fpMandatory:true,
      },

      ],
      rows: [],
      totalRecords: 0,
      pageKey:"_debt_note_list_",
      batchProcess:0,
      batchNum:"",
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_debt_notes') {
                    self.cantAccessPage = true;
                }
            });
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();

    },
    methods: {
      loadList() {
        var self = this;
        self.loading = true;
        var fields = {
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
              action:self.action,
        };
        self.firstLoad = 1;
        $.ajax({
              url: process.env.ROOT_API + "/debtnote-roll-forward/list",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;

                  if (data.status == "success") {
                      if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          self.loadList();
                      } else{
                        console.log(data.content.row);
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;

                      }
                  }else{
                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;

                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-delete')
              }
          });


      }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/reports/DebtNoteRollForwardReport.vue